__turbopack_context__.v({
  "className": "inter_54bbc8e8-module__85LFea__className",
});
